import store from '../'

let resource = store.defineResource({
  name: "users",
  computed: {
    fullName: {
      get () {
        let fullName = this.fname
        if(this.lname) {
          fullName = `${this.fname} ${this.lname}`
        }
        return fullName
      }
    }
  }
})

export default resource



// WEBPACK FOOTER //
// ./src/store/models/user.js